import {ChangeDetectionStrategy, ChangeDetectorRef, Component, DestroyRef, effect, ElementRef, Injectable, input, output, TemplateRef, ViewChild} from '@angular/core';
import {initDebugger} from "felles-ng2/støttefunksjoner/debug";
import {BrukerModell, EnkelGruppeModell, GruppeId, GruppeMedlemListeModell, GruppeRessursClient, MedlemId, MedlemsRolleId, MedlemsRolleModell, MedlemsRollePeriode2Modell, NyRolleSpesifikasjon, OppdaterMedlemSpesifikasjon, RedigerRolleSpesifikasjon, RollePeriodeId, TilgangsrolleMedlem} from "felles-ng2/tjenester/ressurser/generertNg2HttpKlient";
import {AbstractControl, FormArray, FormControl, FormGroup, FormsModule, ReactiveFormsModule, ValidationErrors, ValidatorFn, Validators} from "@angular/forms";
import {MatFormFieldModule} from "@angular/material/form-field";
import {MatInputModule} from "@angular/material/input";
import {MatRadioModule} from "@angular/material/radio";
import {MatIconModule} from "@angular/material/icon";
import {MatDatepickerModule} from "@angular/material/datepicker";
import {MatOptionModule} from "@angular/material/core";
import {NgClass, NgTemplateOutlet} from "@angular/common";
import {MatSelectModule} from "@angular/material/select";
import {FormaterPlainDatePipe} from "felles-ng2/pipes/FormaterPlainDatePipe";
import {TranslateModule} from "@ngx-translate/core";
import {StandardValideringsfeilPipe} from "felles-ng2/pipes/StandardValideringsfeilPipe";
import {MatSlideToggle} from "@angular/material/slide-toggle";
import {InlineSkjemaKomponent} from "web-ng2/delt/komponenter/inline-skjema/inline-skjema";
import {InlineSkjemaTittelKomponent} from "web-ng2/delt/komponenter/inline-skjema/inline-skjema-tittel/inline-skjema-tittel";
import {InlineSkjemaHandlingerKomponent} from "web-ng2/delt/komponenter/inline-skjema/inline-skjema-handlinger/inline-skjema-handlinger";
import {NavigasjonforhindretFlashDirektiv} from "web-ng2/delt/direktiver/navigasjonforhindret-flash/navigasjonforhindret-flash";
import {MatButton, MatIconButton} from "@angular/material/button";
import {VisSpinnerDirektiv} from "web-ng2/delt/direktiver/button--visSpinner/button--visSpinner";
import {Observable} from "rxjs";
import {erPlainDateTidligereEnn} from "felles-ng2/støttefunksjoner/temporal";
import {MedlemRedigerTilgangsrollerKomponent} from "../medlem-rediger-tilgangsroller/medlem-rediger-tilgangsroller";
import {MatDialog, MatDialogActions, MatDialogContent, MatDialogRef, MatDialogTitle} from "@angular/material/dialog";
import {Temporal} from "temporal-polyfill";
import {takeUntilDestroyed} from "@angular/core/rxjs-interop";
import {nyUuid} from "felles-ng2/støttefunksjoner/uuidGenerator";
import {MatMenu, MatMenuItem, MatMenuTrigger} from "@angular/material/menu";
import {erIkkeNil, erNil} from "felles-ng2/støttefunksjoner/nilsjekk";
import {TipsKomponent} from "web-ng2/delt/komponenter/tips/tips";
import {InlineMeldingKomponent} from "web-ng2/delt/komponenter/inline-melding/inline-melding";
import {BrukerkontekstTilbyder} from "felles-ng2/tjenester/BrukerkontekstTilbyder";
import {lesDatoPeriodeUtenTid, periodeOverlapper, PlainDatePeriodeMuligÅpenSlutt, skrivDatoPeriodeUtenTid} from "felles-ng2/støttefunksjoner/plainDatePerioder";
import {MedlemInformasjonKomponent} from "../medlem-informasjon/medlem-informasjon";
import {GruppemedlemDatatjeneste} from "felles-ng2/tjenester/datalager/GruppemedlemDatatjeneste";
import {MedlemStengTilgangBekreftelseKomponent} from "web-ng2/moduler/medlem/komponenter/medlem-steng-tilgang-bekreftelse/medlem-steng-tilgang-bekreftelse";
import {lagrerSignal} from "felles-ng2/tjenester/LagrerIndikator";
import {FormaterDatoPeriodeUtenTidPipe} from "felles-ng2/pipes/FormaterDatoPeriodeUtenTidPipe";
import {Klokke} from "felles-ng2/tjenester/Klokke";
import PlainDate = Temporal.PlainDate;
import {asynkArbeidPågårSignal} from "felles-ng2/tjenester/AsynkArbeidPågårSignal";

const debug = initDebugger('MedlemRedigerKomponent');

export type EksisterendeRollePeriodeSkjemaType = ReturnType<typeof eksisterendeRolleperiodeSkjema>;
export type EksisterendeRollePeriodeSkjemaVerdi = EksisterendeRollePeriodeSkjemaType['value'];
export type NyRollePeriodeSkjemaType = ReturnType<typeof nyRolleperiodeSkjema>;

@Component({
    selector: 'medlem-rediger',
    templateUrl: './medlem-rediger.html',
    styleUrl: './medlem-rediger.scss',
    imports: [
        NgClass,
        NgTemplateOutlet,
        FormsModule,
        ReactiveFormsModule,
        MatFormFieldModule,
        MatInputModule,
        MatRadioModule,
        MatIconModule,
        MatDatepickerModule,
        MatSlideToggle,
        MatOptionModule,
        MatSelectModule,
        MatButton,
        MatDialogContent,
        MatDialogActions,
        MatIconButton,
        MatMenu,
        MatMenuItem,
        MatMenuTrigger,
        MatDialogTitle,
        TranslateModule,
        FormaterDatoPeriodeUtenTidPipe,
        FormaterPlainDatePipe,
        StandardValideringsfeilPipe,
        InlineSkjemaKomponent,
        InlineSkjemaTittelKomponent,
        InlineSkjemaHandlingerKomponent,
        NavigasjonforhindretFlashDirektiv,
        VisSpinnerDirektiv,
        MedlemRedigerTilgangsrollerKomponent,
        TipsKomponent,
        InlineMeldingKomponent,
        MedlemInformasjonKomponent,
        MedlemStengTilgangBekreftelseKomponent
    ],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class MedlemRedigerKomponent {

    @ViewChild('nyRolleperiodeTemplate') private nyRolleperiodeTemplate!: TemplateRef<ElementRef>;
    @ViewChild('redigerRolleperiodeTemplate') private redigerRolleperiodeTemplate!: TemplateRef<ElementRef>;
    @ViewChild('avsluttRolleperiodeTemplate') private avsluttRolleperiodeTemplate!: TemplateRef<ElementRef>;
    @ViewChild('slettRolleperiodeTemplate') private slettRolleperiodeTemplate!: TemplateRef<ElementRef>;

    vedLagret = output<void>();
    vedAvbryt = output<void>();

    medlem = input.required<GruppeMedlemListeModell>();
    gruppe = input.required<EnkelGruppeModell>();

    skjema = new FormGroup({
        tilgangsroller: new FormControl<TilgangsrolleMedlem[]>([TilgangsrolleMedlem.lese], {nonNullable: true}),
        nyeMedlemsroller: new FormArray<NyRollePeriodeSkjemaType>([]),
        aktiveMedlemsroller: new FormArray<EksisterendeRollePeriodeSkjemaType>([]),
        inaktiveMedlemsroller: new FormArray<EksisterendeRollePeriodeSkjemaType>([])
    });

    visInaktiveMedlemsroller = false;
    tilgjengeligRoller: MedlemsRolleModell[] = [];

    lagrer = asynkArbeidPågårSignal();

    /** skjema bak nyRolleperiodeTemplate */
    nyRolleSkjema = nyRolleperiodeSkjema();
    /** skjema bak redigerRolleperiodeTemplate/avsluttRolleperiodeTemplate/slettRolleperiodeTemplate */
    redigerRolleSkjema: EksisterendeRollePeriodeSkjemaType | null = null;
    /** skjemalinjen som redigeres, redigerRolleSkjema er satt til en kopi av denne, ved fullført redigering må oppdaterte verdier kopieres tilbake hit */
    private eksisterendeRolleperiodeSomRedigeres: EksisterendeRollePeriodeSkjemaType | null = null;

    //spesifikt for nyRolleperiodeTemplate
    /** Eventuell overlappende periode men der rollene er ULIKE */
    overlappendePeriode: Rolleperiode | null = null;

    //spesifikt for avsluttRolleperiodeTemplate
    avsluttRolleperiodeTrinn: 'avslutt' | 'stengTilgang' = 'avslutt';
    visStengTilgangOpsjon = false;

    private aktivDialog: MatDialogRef<any> | null = null;

    constructor(private avhengigheter: MedlemRedigerKomponentAvhengigheter,
                private klokke: Klokke,
                private cdRef: ChangeDetectorRef,
                private destroyRef: DestroyRef,
                private dialog: MatDialog) {
        effect(() => {
            if (erNil(this.medlem()) || erNil(this.gruppe())) return;
            this.medlemOgGruppeAngitt();
            this.tvingOppfriskningAvGUI(); //uten denne har kai opplevd at endringer i skjema utført av medlemOgGruppeAngitt() ikke reflekteres i GUI
        });
    }

    erValgtRolle(a: MedlemsRolleModell | null, b: MedlemsRolleModell | null) {
        return a?.id === b?.id;
    }

    slettNyRolleperiode(nyRolle: NyRollePeriodeSkjemaType) {
        const indeks = this.skjema.controls.nyeMedlemsroller.controls.indexOf(nyRolle);
        this.skjema.controls.nyeMedlemsroller.removeAt(indeks);
    }

    async lagre(stengTilgang = false) {
        await this.lagrer.utfør(async () => {
            const spesifikasjon = this.somSpesifikasjon();
            await this.avhengigheter.oppdater(this.medlem().id, spesifikasjon);
            if (stengTilgang) await this.avhengigheter.stengTilgang(this.medlem().id);
            this.vedLagret.emit();
        });
    }

    avbryt() {
        this.vedAvbryt.emit()
    }

    // ny rolle dialog

    visNyRolleperiodeDialog() {
        this.nyRolleSkjema = nyRolleperiodeSkjema();
        this.nyRolleSkjema.addValidators(this.nyRolleperiodeSkjemaValidator())
        this.åpneDialog(this.nyRolleperiodeTemplate);
    }

    registrerNyRolleperiode() {
        this.skjema.controls.nyeMedlemsroller.push(this.nyRolleSkjema);
        this.lukkAktivDialog();
        this.tvingOppfriskningAvGUI();
    }

    // rediger rolle dialog

    visRedigerRolleperiodeDialog(rolle: EksisterendeRollePeriodeSkjemaType) {
        this.setRedigerRolleSkjema(rolle);
        this.redigerRolleSkjema!.addValidators(this.eksisterendeRolleperiodeSkjemaValidator())
        this.åpneDialog(this.redigerRolleperiodeTemplate);
    }

    oppdaterRolleperiode() {
        if (!this.redigerRolleSkjema!.value.harSluttdato)
            this.redigerRolleSkjema!.controls.sluttdato.setValue(null);
        this.oppdaterRolleperiodeSomRedigeres();
        this.lukkAktivDialog();
    }

    // avslutt rolle dialog

    visAvsluttRolleperiodeDialog(rolle: EksisterendeRollePeriodeSkjemaType) {
        this.setRedigerRolleSkjema(rolle);
        //kun vis "steng tilgang" opsjonen dersom medlem kun har 1 aktiv rolle, og medlemmet vi redigerer ikke er kallende bruker
        this.visStengTilgangOpsjon = this.erEnesteAktiveRolle(rolle.value) && !this.brukerRedigererSegSelv();
        this.åpneDialog(this.avsluttRolleperiodeTemplate);
    }

    gaaTilStengTilgangTrinn() {
        this.avsluttRolleperiodeTrinn = 'stengTilgang';
    }

    avsluttRolleperiode() {
        this.markerRolleSomAvsluttet();
        this.lukkAktivDialog();
    }

    /** avslutter rollen og stenger tilgang for dette medlemmet.
     * Merk at i motsetning til andre modale involvert i redigering av medlem
     * vil vi her også utføre lagring og terminere redigeringsmodus */
    async avsluttRolleperiodeOgStengTilgang() {
        this.markerRolleSomAvsluttet();
        await this.lagre(true);
        this.lukkAktivDialog();
    }

    private markerRolleSomAvsluttet() {
        this.redigerRolleSkjema!.controls.avsluttet.setValue(true);
        this.redigerRolleSkjema!.controls.harSluttdato.setValue(true);
        this.oppdaterRolleperiodeSomRedigeres();
    }

    // slett rolle dialog

    visSlettAktivRolleperiodeDialog(rolle: EksisterendeRollePeriodeSkjemaType) {
        this.setRedigerRolleSkjema(rolle);
        this.åpneDialog(this.slettRolleperiodeTemplate);
    }

    slettAktivRolleperiode() {
        this.redigerRolleSkjema!.controls.slettet.setValue(true);
        this.oppdaterRolleperiodeSomRedigeres();
        this.lukkAktivDialog();
    }

    // på tvers av dialoger

    avbrytAktivDialog() {
        this.lukkAktivDialog();
    }

    //private hjelpemetoder

    private medlemOgGruppeAngitt() {
        this.skjema.patchValue({
            tilgangsroller: this.medlem().tilgangsroller
        });

        //hent gruppens roller
        this.avhengigheter.medlemsroller(this.gruppe().id)
          .pipe(takeUntilDestroyed(this.destroyRef))
          .subscribe(roller => this.tilgjengeligRoller = roller);

        //populer skjema for eksisterende aktive roller
        this.skjema.controls.aktiveMedlemsroller.clear();
        this.medlem().aktiveMedlemsroller
          .map(rolle => eksisterendeRolleperiodeSkjema(rolle))
          .forEach(kontroller => this.skjema.controls.aktiveMedlemsroller.push(kontroller));


        //populer skjema for eksisterende inaktive roller
        this.skjema.controls.inaktiveMedlemsroller.clear();
        this.medlem().inaktiveMedlemsroller
          .map(rolle => eksisterendeRolleperiodeSkjema(rolle))
          .forEach(kontroller => this.skjema.controls.inaktiveMedlemsroller.push(kontroller));
    }

    private setRedigerRolleSkjema(rolle: EksisterendeRollePeriodeSkjemaType) {
        this.eksisterendeRolleperiodeSomRedigeres = rolle;
        this.redigerRolleSkjema = eksisterendeRolleperiodeSkjemaFraSkjemaverdier(rolle.value);
    }

    private oppdaterRolleperiodeSomRedigeres() {
        this.eksisterendeRolleperiodeSomRedigeres!.patchValue(this.redigerRolleSkjema!.value);
        this.tvingOppfriskningAvGUI(); //uten dette kalles oppdateres ikke gui..
    }

    private eksisterendeRolleperiodeSkjemaValidator(): ValidatorFn {
        return (skjema: AbstractControl): ValidationErrors | null => {
            const eksisterendeRolleperiodeSkjema = <EksisterendeRollePeriodeSkjemaType>skjema; //ValidatorFn krever at skjema arg er deklarert som AbstractControl
            const skjemaverdier = eksisterendeRolleperiodeSkjema.value;
            if (erNil(skjemaverdier.startdato)) return null;
            this.validerRolleperiode({periodeId: skjemaverdier.rolleperiode!.id, rolleId: skjemaverdier.rolleperiode!.medlemsrolleId, rolleTittel: skjemaverdier.rolleperiode!.tittel, periode: this.somPlainDatePeriodeMuligÅpenSlutt(skjemaverdier)}, eksisterendeRolleperiodeSkjema.controls.startdato);
            return null; //validerRolleperiode vil ha satt eventuelle feil
        }
    }

    private nyRolleperiodeSkjemaValidator(): ValidatorFn {
        return (skjema: AbstractControl): ValidationErrors | null => {
            const nyRolleperiodeSkjema = <NyRollePeriodeSkjemaType>skjema; //ValidatorFn krever at skjema arg er deklarert som AbstractControl
            const skjemaverdier = (<NyRollePeriodeSkjemaType>nyRolleperiodeSkjema).value;
            if (erNil(skjemaverdier.rolle) || erNil(skjemaverdier.startdato)) return null;
            this.validerRolleperiode({periodeId: skjemaverdier.id!, rolleId: skjemaverdier.rolle.id, rolleTittel: skjemaverdier.rolle.tittel, periode: this.somPlainDatePeriodeMuligÅpenSlutt(skjemaverdier)}, nyRolleperiodeSkjema.controls.startdato);
            return null; //validerRolleperiode vil ha satt eventuelle feil
        }
    }

    private validerRolleperiode(rolleTilKontroll: Rolleperiode, startdatofelt: FormControl) {
        const alleIkkeslettedeRolleperioder = [...this.skjema.value.aktiveMedlemsroller!, ...this.skjema.value.inaktiveMedlemsroller!]
          .filter(rolle => !rolle.slettet) //utelat slettede
          .filter(rolle => erIkkeNil(rolle.startdato)) //utelat eksisterende med ikke-gyldig dato (som regel rollen man er i ferd med å redigere)
          .map(rolle => ({periodeId: rolle.rolleperiode!.id, rolleId: rolle.rolleperiode!.medlemsrolleId, rolleTittel: rolle.rolleperiode!.tittel, periode: this.somPlainDatePeriodeMuligÅpenSlutt(rolle)}));
        this.skjema.value.nyeMedlemsroller!.forEach(nyRolle => alleIkkeslettedeRolleperioder.push({periodeId: nyRolle.id!, rolleId: nyRolle.rolle!.id, rolleTittel: nyRolle.rolle!.tittel, periode: this.somPlainDatePeriodeMuligÅpenSlutt(nyRolle)}));

        const overlappende = alleIkkeslettedeRolleperioder
          .filter(eksisterende => eksisterende.periodeId !== rolleTilKontroll.periodeId)
          .filter(eksisterende => periodeOverlapper(eksisterende.periode, rolleTilKontroll.periode));
        this.overlappendePeriode = overlappende.find(kandidat => kandidat.rolleId != rolleTilKontroll.rolleId) ?? null;
        const overlappendePeriodeIdentiskRolle = overlappende.find(kandidat => kandidat.rolleId == rolleTilKontroll.rolleId);
        startdatofelt.setErrors(erIkkeNil(overlappendePeriodeIdentiskRolle) ? {'overlappendePeriodeIdentiskRolle': overlappendePeriodeIdentiskRolle} : null);
    }

    /** Ekstraherer PlainDatePeriodeMuligÅpenSlutt fra angitt skjema-struktur.
     * Merk at startdato er deklarert som optional og nullable for å være API-kompatibel med skjema.value (som gjør alle felter optional).
     * Vi forventer dog av startdato er ikke-null. */
    private somPlainDatePeriodeMuligÅpenSlutt(plainDatePeriode: {
        startdato?: PlainDate | null;
        sluttdato?: PlainDate | null
    }): PlainDatePeriodeMuligÅpenSlutt {
        return {
            start: plainDatePeriode.startdato!,
            slutt: plainDatePeriode.sluttdato ?? null
        };
    }

    private erEnesteAktiveRolle(rolle: EksisterendeRollePeriodeSkjemaVerdi): boolean {
        return !this.skjema.controls.aktiveMedlemsroller.value
          //utelat rollen vi spør om hvorvidt er eneste aktive
          .filter(kandidat => kandidat.rolleperiode!.id != rolle.rolleperiode!.id)
          .some(kandidat => this.erAktiv(kandidat));
    }

    private erAktiv(rolle: EksisterendeRollePeriodeSkjemaVerdi) {
        //kandidat.avsluttet??
        if (rolle.slettet) return false;
        if (erNil(rolle.sluttdato)) return true; //vi ignorere i denne sammenheng at startdato kan være en fremtidig dato
        return erPlainDateTidligereEnn(this.klokke.nåSomZonedDateTime().toPlainDate(), rolle.sluttdato); //sann dersom sluttdato er senere enn nå
    }

    private brukerRedigererSegSelv() {
        return this.medlem().brukerId === this.avhengigheter.kallendeBruker().id;
    }

    private åpneDialog(template: TemplateRef<ElementRef>) {
        this.aktivDialog = this.dialog.open(template, {width: '500px'});
    }

    private tvingOppfriskningAvGUI() {
        this.cdRef.markForCheck();
    }

    private lukkAktivDialog() {
        this.aktivDialog!.close();
        this.aktivDialog = null;
    }

    private somSpesifikasjon(): OppdaterMedlemSpesifikasjon {
        const verdier = this.skjema.value;
        const oppdaterteMedlemsrolleperioder: RedigerRolleSpesifikasjon[] = [...verdier.aktiveMedlemsroller!, ...verdier.inaktiveMedlemsroller!]
          .map(skjema => ({id: skjema.rolleperiode!.id, ...skrivDatoPeriodeUtenTid(this.somPlainDatePeriodeMuligÅpenSlutt(skjema)), slettet: skjema.slettet!}));
        const nyeMedlemsrolleperioder: NyRolleSpesifikasjon[] = verdier.nyeMedlemsroller!
          .map(skjema => ({id: skjema.id!, ...skrivDatoPeriodeUtenTid(this.somPlainDatePeriodeMuligÅpenSlutt(skjema)), rolleId: skjema.rolle!.id}));
        return {
            tilgangsroller: verdier.tilgangsroller!,
            rolleId: null as any as MedlemsRolleId, // brukes fortsatt i mobil - får typefeil om ikke angitt her
            nyeMedlemsrolleperioder,
            oppdaterteMedlemsrolleperioder
        }
    }
}

type Rolleperiode = {
    periodeId: RollePeriodeId,
    rolleId: MedlemsRolleId,
    rolleTittel: string,
    periode: PlainDatePeriodeMuligÅpenSlutt
}


function eksisterendeRolleperiodeSkjema(rolle: MedlemsRollePeriode2Modell) {
    let periode = lesDatoPeriodeUtenTid(rolle.periode);
    return new FormGroup({
        rolleperiode: new FormControl(rolle),
        startdato: new FormControl<PlainDate>(periode.start, {validators: Validators.required}),
        sluttdato: new FormControl<PlainDate | null>(periode.slutt),
        harSluttdato: new FormControl(erIkkeNil(periode.slutt), {nonNullable: true}),
        avsluttet: new FormControl(false),
        stengTilgang: new FormControl(false),
        slettet: new FormControl(false),
    })
}

function eksisterendeRolleperiodeSkjemaFraSkjemaverdier(verdier: EksisterendeRollePeriodeSkjemaVerdi): EksisterendeRollePeriodeSkjemaType {
    return new FormGroup({
        rolleperiode: new FormControl(verdier.rolleperiode!),
        startdato: new FormControl<PlainDate>(verdier.startdato!),
        sluttdato: new FormControl<PlainDate | null>(verdier.sluttdato!),
        harSluttdato: new FormControl(verdier.harSluttdato!, {nonNullable: true}),
        avsluttet: new FormControl(verdier.avsluttet!),
        stengTilgang: new FormControl(verdier.stengTilgang!),
        slettet: new FormControl(verdier.slettet!),
    })
}

function nyRolleperiodeSkjema() {
    const skjema = new FormGroup({
        id: new FormControl<RollePeriodeId>(nyUuid(), {nonNullable: true}),
        rolle: new FormControl<MedlemsRolleModell | null>(null, {validators: Validators.required}),
        startdato: new FormControl<PlainDate | null>(null, {validators: Validators.required}),
        sluttdato: new FormControl<PlainDate | null>(null),
        harSluttdato: new FormControl(false, {nonNullable: true})
    });

    return skjema;
}


@Injectable()
export class MedlemRedigerKomponentAvhengigheter {

    constructor(private gruppemedlemDatatjeneste: GruppemedlemDatatjeneste, private gruppeRessurs: GruppeRessursClient, private kontekstTilbyder: BrukerkontekstTilbyder) {
    }

    kallendeBruker(): BrukerModell {
        return this.kontekstTilbyder.autentisertBruker().bruker;
    }

    /** Returnerer tilgjengelige medlemsroller */
    medlemsroller(gruppeId: GruppeId): Observable<MedlemsRolleModell[]> {
        return this.gruppeRessurs.finnTilgjengeligeRoller(gruppeId).somObservable();
    }

    async stengTilgang(id: MedlemId): Promise<void> {
        await this.gruppemedlemDatatjeneste.fjernTilgang(id);
    }

    async oppdater(id: MedlemId, spesifikasjon: OppdaterMedlemSpesifikasjon) {
        return this.gruppemedlemDatatjeneste.oppdaterMedlem(id, spesifikasjon);
    }
}
